@if (producerNotFound()) {
<section class="container py-5 text-center">
  <h1 class="h2-bold text-secondary head-font mb-3">Producer Not Found</h1>
  <p class="mb-4">The producer you're looking for doesn't exist or may have been moved.</p>
  <a [routerLink]="['/pages/producers']" class="btn btn-primary">Browse All Producers</a>
</section>
} @else if (producerDetails()) {
<div class="detail">

  <!-- Nav -->
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" (click)="goToHome()">
        <span class="material-symbols-outlined">home</span>
      </li>
      <li class="breadcrumb-item d-flex align-items-center" aria-current="page" (click)="back()">
        <span class="fw-semibold">
          Farmers & Producers
        </span>
      </li>
      <li class="breadcrumb-item d-flex align-items-center" aria-current="page">
        <span class="fw-bold">
          {{producerDetails()?.name}}
        </span>
      </li>
    </ol>
  </nav>

  <!-- Producer info -->
  <section class="mb-3">
    <!-- Main info -->
    <div class="d-none d-md-flex flex-row gap-5">

      <!-- Image -->
      <div class="detail__img w-40">
        <img [src]="producerDetails()?.img" alt="{{ producerDetails()?.name }}" (error)="handleImageError($event)"
          class="w-100" />
      </div>

      <!-- Description -->
      <div class="detail__main w-60">

        <div class="mb-3">
          <h1 class="h1-bold text-secondary mb-0 section-title">
            <span>{{producerDetails()?.name}}</span>
          </h1>

          <!-- @if (producerDetails()?.location) {
          <h4 class="h7-semibold align-items-center d-flex gap-2 detail__location">
            <span class="material-symbols-outlined">
              location_on
            </span>
            {{producerDetails()?.location}}
          </h4>
          } -->
        </div>

        <!-- <hr class="m-0"> -->
        @defer(on viewport) {
        <div class="mt-3">
          <p [innerHTML]="sanitizeHtml(producerDetails().description)"></p>
        </div>
        } @placeholder{<div></div>}

      </div>

    </div>

    <!-- Main info mobile -->
    <div class="d-md-none">

      <img [src]="producerDetails()?.img" class="img-fluid" alt="{{ producerDetails()?.name }}" />

      <h1 class="section-title h1-bold text-secondary mt-3">
        <span>{{producerDetails()?.name}}</span>
      </h1>

      <!-- <h4 class="h7-semibold align-items-center d-flex gap-2 detail__location mb-3">
        <span class="material-symbols-outlined">
          location_on
        </span>
        {{producerDetails()?.location}}
      </h4> -->

      <!-- <hr class="m-0"> section-title -->

      @defer(on viewport) {
      <div class="mt-3">
        <p [innerHTML]="sanitizeHtml(producerDetails().description)"></p>
      </div>
      } @placeholder{<div></div>}

    </div>

  </section>

  <!-- Carousel -->
  @defer(on viewport) {
  @if(producerDetails().products.length) {
  <section class="mt-4">

    <h2 class="h3-bold text-secondary mb-3 section-title">
      <span>Their Products</span>
    </h2>

    <app-carousel [items]="carouselProducerProducts()" [type]="'producerProduct'"
      [hasMoreItems]="producerDetails()?.hasMoreProducts">
    </app-carousel>

  </section>
  }
  } @placeholder{<div></div>}

</div>
}
